/**
 * Animations on Recipe landing page
 * we are using DOMContentLoaded event, so we are not waiting for all images and scripts being loaded
 */
/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-posts-3-columns').forEach((list) => {
    list.querySelectorAll('.js-posts-3-columns li').forEach((el, index) => {
      const delay = (index % 3) * 100;
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-delay', delay);
    });
  });

  document.querySelectorAll('.js-posts-4-columns').forEach((list) => {
    list.querySelectorAll('.js-posts-4-columns li').forEach((el, index) => {
      const delay = (index % 4) * 100;
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-delay', delay);
    });
  });

  AOS.init({
    once: true,
    offset: 0,
    duration: 600,
    disable: 'mobile',
  });
});
